export const ROUTE_PATH = '/merchants/:merchantId';
